import PostFooterWrapper from 'components/Blog/Post/PostFooter/styled/PostFooterWrapper';
import Arrow from 'components/Icons/Arrow';
import Image from 'next/image';
import React from 'react';
import CmsMediaType from 'types/cmsMedia';
import { openUrl } from 'utils/windowUtils';
import ArrowWrapper from './styled/ArrowWrapper';
import FooterImage from './styled/FooterImage';

type Props = {
  image?: CmsMediaType;
  link?: string;
};

const PostFooter = ({ image, link }: Props) => {
  const onClick = link ? () => openUrl(link) : undefined;

  return (
    <PostFooterWrapper>
      {link && (
        <ArrowWrapper
          onClick={onClick}
          whileHover={{ x: '-10%' }}
          whileTap={{ x: '-10%' }}
        >
          <Arrow />
        </ArrowWrapper>
      )}
      {image && (
        <FooterImage>
          <Image
            src={image.url}
            quality={100}
            layout={'fill'}
            priority={true}
          />
        </FooterImage>
      )}
    </PostFooterWrapper>
  );
};

export default PostFooter;
